import {createStyles, Theme} from "@material-ui/core";
import {primaryColor, styleColors, typography} from "src/main.style";

export const imageFlowStyle = (theme: Theme) => createStyles({
  root: {
    padding: theme.spacing(3.25, 2.5, 2.5),

    '& > *': {
      boxSizing: 'border-box',
    }
  },
  imagesList: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexFlow: 'wrap',
    gap: theme.spacing(3.75),
    position: 'relative',
  },
  card: {
    display: 'flex',
    padding: theme.spacing(3.25, 2.5, 2.5),
    flexDirection: 'column',
    gap: theme.spacing(2),
    boxShadow: theme.shadows[4],
    borderRadius: '14px',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
    width: '100%',
    minWidth: '320px',
    maxWidth: '420px',
    position: 'relative',
    border: `1px solid ${styleColors.blackAlpha23}`,
    transition: 'all 0.5s',
    zIndex: 1,
  },
  cardTop: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: theme.spacing(1.25),
    alignSelf: 'stretch',
  },
  topMiddle: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1,
  },
  img: {
    width: '100%',
    backgroundColor: styleColors.greyMedium1,
    height: 'min(400px, calc(100vw - 32px))',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  postImg: {
    backgroundColor: styleColors.greyMedium1,
    height: 'min(400px, calc(100vw - 32px))',
    marginRight: theme.spacing(-2.5),
    marginLeft: theme.spacing(-2.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  name: {
    flex: 1,
    color: theme.palette.common.black,
    borderWidth: 0,
    outlineWidth: 0,
    padding: '0px',
    ...typography.input,
    fontSize: '1.125rem',
    minWidth: '150px'
  },
  date: {
    ...typography.placeholder,
    color: theme.palette.common.black,
  },
  moreOptionsButton: {
    fontSize: '24px',
    padding: 0,
    margin: 0,
    width: 'auto',
    height: 'auto',
    minWidth: 'unset',
  },
  menuPaper: {
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[4],
  },
  menuList: {
    padding: theme.spacing(1, 0),
  },
  menuListItem: {
    ...typography.input,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  avatars: {
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'flex-Start',
    gap: theme.spacing(0.5),
  },
  cardBottom: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(0.25),
  },
  downloadLink: {
    color: styleColors.primaryTextBlack87,
    textDecoration: 'none',
    fontWeight: 500,
  },
  seenBy: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(0.25),
    ...typography.placeholder,
    fontSize: '0.666666rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
    color: styleColors.greyMedium2,
  },
  editComment: {
    ...typography.input,
    color: theme.palette.common.black,
    padding: 0,
    margin: 0,
    border: 0,
    flex: 1,
    outline: 'none',

    '&::placeholder': {
      ...typography.placeholder,
      color: styleColors.warmGrey,
    }
  },
  FAB: {
    color: '#FFFFFF',
    width: '62px',
    cursor: 'pointer',
    height: '62px',
    fontSize: '45px',
    boxShadow: `0px 3px 30px ${styleColors.fabShadow}`,
    backgroundColor: primaryColor,

    lineHeight: '45px',
    userSelect: 'none',
    WebkitUserSelect: 'none',
    justifyContent: 'center',
    right: '20px',
    bottom: '100px',
    display: 'flex',
    zIndex: 3,
    overflow: 'hidden',
    position: 'absolute',
    boxSizing: 'border-box',
    transition: 'all 0.2s',
    alignItems: 'center',
    borderRadius: '31px',
    webkitUserSelect: 'none',

  },
  fabHide: {
    opacity: 0,
    pointerEvents: 'none',
  },
  sendButton: {
    fontSize: '18px',
    width: 'auto',
    height: 'auto',
    padding: 0,
    margin: 0,
    transition: 'all 0.2s',
    transitionDelay: '200ms',
    opacity: 1,
    cursor: 'pointer',
  },
  centerHeart: {
    fill: styleColors.white,
    width: '60px',
    height: '60px',
    opacity: 0,
    transition: 'all 0.5s',
  },
  addImageButton: {
    width: '100px',
    height: '100px',
    backgroundColor: styleColors.greyLight2,
    borderRadius: '200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: styleColors.white,
    fontSize: '90px',
    fontWeight: 500,
    cursor: 'pointer',
  },
  newPostDialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  newPostContent: {
    display: 'flex',
    minHeight: 'min(calc(100vw - 64px),400px);',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'center',
    width: `100%`,
    maxWidth: '400px',
    padding: 0,
  },
  percentageText: {
    fontWeight: 700,
    fontSize: '33px',
    color: styleColors.white,
    textShadow: `${styleColors.black} 0 0 10px`,
  },
  helpText : {
    color: styleColors.greyMedium1, 
    fontSize: '17px',  
    textShadow: `0px 1px 0px ${styleColors.whiteOverlay28}, 0px -1px 0px ${styleColors.blackInset33}`
  },
  enableEdit : {
    display:'none',
  },
  disableEdit : {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: styleColors.whiteOverlay72,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fabRotate : {
    position: 'absolute',
    minWidth: 40,
    minHeight: 40,
    backgroundColor: styleColors.white,
    borderRadius: 50,
    display: 'flex',
    top: 6,
    left: 6,
    alignItems: 'center',
    justifyContent: 'center',
  }
});



// WEBPACK FOOTER //
// ./src/components/imageflow/imageflow.style.ts